import { Tooltip } from 'antd';
import moment, { ISO_8601 } from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import { RelativeTime } from 'components/atoms/relative-time';
import { Label01, Text03 } from 'components/styles';

const Container = styled.div`
  display: flex;
  flex: 0 0 auto;
  ${Text03};
  ${Label01};
`;

const Time = styled.span`
  cursor: default;
`;

export const Timestamp: FC<{ timestamp: string }> = ({ timestamp }) => (
  <Container>
    <Tooltip title={moment(timestamp, ISO_8601).format('LLL')}>
      <Time>
        <RelativeTime time={moment(timestamp, ISO_8601)} />
      </Time>
    </Tooltip>
  </Container>
);
